import { createListenerMiddleware } from '@reduxjs/toolkit'
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'

import { InfoApiResponse, InfoResponse } from './type'

const fetchBaseQueryWithRetry = retry(fetchBaseQuery({ baseUrl }), {
  maxRetries: 3,
})

export const queryInfo = createApi({
  baseQuery: fetchBaseQueryWithRetry,
  endpoints: (builder) => ({
    getInfo: builder.query<InfoResponse, void>({
      query: () => apiPath.info,
      transformResponse: (response: InfoApiResponse) => {
        const { mainChainId, ...data } = response
        return { ...data, chainId: mainChainId }
      },
    }),
  }),
  reducerPath: 'info',
})

export const { useGetInfoQuery, useLazyGetInfoQuery } = queryInfo

const infoMiddleware = createListenerMiddleware()

export { infoMiddleware }
